export const Snag = {
    MODES : {
        UNACTIONED : 1,
        UNSIGNED : 2,
        COMPLETE : 3
    }
}